import * as remoteAction from "../remoteAction";

export type GetShopifyVariantsActionSuccess =
  remoteAction.MerchantRemoteResponse<
    "GET_SHOPIFY_VARIANTS_SUCCESS",
    {
      data: {
        variants: {
          id: string;
          title: string;
          sku: string;
          price: string;
          compareAtPrice: string | null;
          inventoryQuantity: number;
          inventoryPolicy: string;
          product: {
            id: string;
            title: string;
            featuredImage: { url: string };
          };
        }[];
      };
    }
  >;

export type GetShopifyVariantsActionFailure =
  remoteAction.MerchantRemoteResponse<"GET_SHOPIFY_VARIANTS_FAILURE", any>;

export type GetShopifyVariantsActionRequest =
  remoteAction.MerchantRemoteResponse<"GET_SHOPIFY_VARIANTS_REQUEST", any>;

export interface GetShopifyVariantsAction
  extends remoteAction.GetRemoteRequest {
  types: {
    request: "GET_SHOPIFY_VARIANTS_REQUEST";
    success: "GET_SHOPIFY_VARIANTS_SUCCESS";
    failure: "GET_SHOPIFY_VARIANTS_FAILURE";
  };
}

/**
 * Fetch specific Shopify variants by IDs
 * @param variantIds array of Shopify GIDs for variants
 */
export function getShopifyVariants(
  variantIds: string[]
): GetShopifyVariantsAction {
  const query = encodeURIComponent(variantIds.join(","));

  return {
    method: "GET",
    type: "MERCHANT_REMOTE_REQUEST",
    types: {
      failure: "GET_SHOPIFY_VARIANTS_FAILURE",
      request: "GET_SHOPIFY_VARIANTS_REQUEST",
      success: "GET_SHOPIFY_VARIANTS_SUCCESS",
    },
    https: true,
    url: `/shopify/variants?variantIds=${query}`,
  };
}
